const publicMenus = [
  { icon: "home", title: "Login", path: "/" },
  { icon: "lock_open", title: "Lupa Password", path: "/lupa-password" },
  {
    icon: "info_outline",
    title: "Tentang Aplikasi",
    path: "/tentang-aplikasi"
  },
  { icon: "copyright", title: "Privacy Policy", path: "/kebijakan-privasi" }
];

export default publicMenus;
